import { useDynamicConfig } from 'hooks/use-dynamic-config.hook';
import { useConfigWithFeatureFlags } from 'hooks/use-config-with-feature-flags';
import { useConditionalNavigation } from 'hooks/use-conditional-navigation.hook';
import { useInterceptLinkClick } from 'hooks/use-intercept-link-click.hook';
import { useProductSegmentation } from 'hooks/use-product-segmentation.hook';
import { PARTNER_TOKEN_CONFIG } from 'common/partner-config';

interface UseAppRoutesReturn {
  // Data
  isFormCenterAvailable: boolean;

  // Actions
  initializeApp: () => void;
}

export const useAppRoutes = (): UseAppRoutesReturn => {
  // Initialize app-wide hooks
  useDynamicConfig();
  useConfigWithFeatureFlags();
  useConditionalNavigation();
  useInterceptLinkClick({
    patternsToIntercept: [
      ...PARTNER_TOKEN_CONFIG.REGULAR_PATTERNS,
      ...PARTNER_TOKEN_CONFIG.SECURED_PATTERNS,
    ],
    rootUrl: import.meta.env.VITE_LINKOUT_ROOT_URL,
  });

  const { showFormsCenter } = useProductSegmentation();
  const isFormCenterAvailable = showFormsCenter;

  const initializeApp = () => {};

  return {
    // Data
    isFormCenterAvailable,

    // Actions
    initializeApp,
  };
};
